<template>
  <div :class="'base-create ' + (currentStep > componentStep ? 'create-class-com-disable' : '')">
    <Header :addLearnerStep="componentStep" :title="title" :organizationType="organizationType">
      <template v-slot:tooltip>
        <el-tooltip
          :content="$t($i18nLabelsHelper(organizationType, 'create_group_flow.add_students.add_students_tooltip'))"
        >
          <i class="el-icon-warning-outline" />
        </el-tooltip>
      </template>
    </Header>
    <div v-if="!isOrgUseDummyEmail" class="base-create-body">
      <picker :options="options" :picked.sync="picked" />
      <el-form v-if="picked === 'email-invite'">
        <emails-tags-input
          :label="$t('classes.create_class_flow.add_students.copy_paste_emails')"
          :placeholder="
            $t($i18nLabelsHelper(organizationType, 'create_group_flow.add_students.add_students_input_placeholder'))
          "
          :currentEmails="addLearners.users"
          @updatedTags="setTags"
          ref="tags"
        />
      </el-form>
      <el-form v-if="picked === 'import-users'" class="uploader" name="fileList">
        <import-uploader
          :organizationId="organizationId"
          :form="form"
          v-on:update-form="updateForm"
          v-on:update-add-learner="updateAddLearner"
          :isOrganizationUseDummyEmail="isOrgUseDummyEmail"
        >
        </import-uploader>
      </el-form>
    </div>
    <div v-else class="base-create-body">
      <el-form class="uploader" name="fileList">
        <import-uploader
          :organizationId="organizationId"
          :form="form"
          v-on:update-form="updateForm"
          v-on:update-add-learner="updateAddLearner"
          :isOrganizationUseDummyEmail="isOrgUseDummyEmail"
        >
        </import-uploader>
      </el-form>
    </div>
  </div>
</template>

<script>
import EmailsTagsInput from "@/components/common/EmailsTagsInput";
import Header from "@/components/common/add-learners/Header";
import Picker from "@/components/common/Picker";
import ImportUploader from "@/components/common/add-learners/ImportUploader";
import { mapGetters } from "vuex";
import { compose, defaultTo, path } from "ramda";

function initialState() {
  return {
    picked: "email-invite",
    actionUrl: "",
    uploadId: null,
    loading: false,
    errors: null,
    numberOfEmails: 0,
    form: {
      students: [],
      fileList: [],
    },
  };
}

export default {
  components: {
    Header,
    EmailsTagsInput,
    Picker,
    ImportUploader,
  },
  props: {
    currentStep: {
      type: Number,
      default: 3,
    },
    componentStep: {
      type: Number,
      default: 3,
    },
    organizationType: {
      type: String,
      default: "",
    },
    organizationId: {},
    addLearners: {},
    isOrganizationUseDummyEmail: {
      type: Boolean,
      default: undefined,
    },
  },
  data() {
    return {
      ...initialState(),
      validations: [
        {
          classes: "no-email",
          rule: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
          disableAdd: true,
        },
      ],
      options: [
        {
          input: "email-invite",
          icon: "elsa-icon-copy-blue",
          iconActive: "elsa-icon-copy-blue",
          name: this.$t("organizations.invite_users.mail_invite"),
        },
        {
          input: "import-users",
          icon: "elsa-icon-import-black",
          iconActive: "elsa-icon-import",
          name: this.$t("organizations.invite_users.import_users"),
        },
      ],
    };
  },
  methods: {
    resetModal() {
      Object.assign(this.$data, initialState());
    },
    updateAddLearner(klass) {
      this.$emit("update-add-learner", klass);
    },
    handleClickContinute() {
      if (this.picked === "email-invite" && !this.isOrgUseDummyEmail) {
        this.handleInviteUsers();
      } else {
        this.handleImportUsers();
      }
    },
    handleInviteUsers() {
      // This click event will add the student emails by clicking on next button
      this.$refs.tags.$el.click();
      this.$emit("next-step", this.currentStep);
    },
    handleImportUsers() {
      if (this.isOrgUseDummyEmail) {
        this.$emit("next-step", this.currentStep, {
          mode: "file-import",
          uploadId: this.uploadId,
        });
      } else {
        if (this.form.fileList.length) {
          this.$emit("next-step", this.currentStep, {
            mode: "file-import",
            uploadId: this.uploadId,
          });
        } else {
          this.$emit("next-step", this.currentStep);
        }
      }
    },
    setTags(newEmails) {
      const users = newEmails.map(newEmail => {
        return {
          ...newEmail,
          selectedTeam: undefined,
        };
      });
      this.updateAddLearner({
        users,
      });
    },
    updateForm(newUpdate) {
      this.form = {
        ...this.form,
        ...newUpdate,
      };
    },
  },
  computed: {
    organizationName() {
      const organizationName = compose(
        defaultTo(this.$store.getters["organization/currentOrganization"].name),
        path(["organizationData", "name"])
      )(this);

      return organizationName;
    },
    isOrgUseDummyEmail() {
      if (this.isOrganizationUseDummyEmail === undefined) {
        return this.$store.getters["organization/isOrganizationUseDummyEmail"];
      } else {
        return this.isOrganizationUseDummyEmail;
      }
    },
    title() {
      return `${this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "add_students"))}`;
    },
    ...mapGetters({
      classes: "classes/getClassList",
      currentOrganizationType: "organization/currentOrganizationType",
      useDummyEmail: "organization/isOrganizationUseDummyEmail",
    }),
  },
};
</script>

<style lang="scss" scoped></style>
